export default __webpack_public_path__ + "static/media/crypto.5500fb3d.png";